module.exports = __webpack_public_path__ + "static/media/game_cover_flamingcore.914f75f0.png";